var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuarterAllocationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pie_chart_24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Light_Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    opacity: 0.5,
    d: "M4 12C4 16.07 7.06 19.44 11 19.93V4.07001C7.06 4.56001 4 7.93001 4 12Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "Light_Color_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    opacity: 0.5,
    d: "M13 19.93C16.61 19.48 19.48 16.61 19.93 13H13V19.93Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "Light_Color_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_3",
    opacity: 0.5,
    d: "M13 4.07001V11H19.93C19.48 7.39001 16.61 4.52001 13 4.07001Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "Dark_Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM4 12C4 16.07 7.06 19.44 11 19.93V4.07C7.06 4.56 4 7.93 4 12ZM13 19.93V13H19.93C19.48 16.61 16.61 19.48 13 19.93ZM13 4.07V11H19.93C19.48 7.39 16.61 4.52 13 4.07Z",
    fill: "white",
    fillOpacity: 0.54
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuarterAllocationIcon);
export default __webpack_public_path__ + "static/media/quarterAllocationIcon.046262ab070f0c1c2ef179c77bf0e5e8.svg";
export { ForwardRef as ReactComponent };